import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { AzavistaApiService, AzavistaApiUtilsService } from '@azavista/servicelib';
import { VIEW_NAVIGATOR_ENTITY_SERVICELIB_METHODS, ViewNavigatorEntityServiceLibMethodRecordKey } from './customer-chatbot/view-host.context.utils';
import { ViewHostContextService } from './customer-chatbot/view-host-context.service';

@Injectable({
    providedIn: 'root',
})
export class AzavistaApiProxyService extends AzavistaApiService {
    private _viewHostContextSvc = inject(ViewHostContextService);

    constructor(http: HttpClient, utilsSvc: AzavistaApiUtilsService) {
        super(http, utilsSvc);

        // Return a Proxy wrapping the current instance ('this')
        return new Proxy(this, {
            get(target, propKey, receiver) {
            const targetValue = Reflect.get(target, propKey, receiver);

            if (typeof targetValue === 'function') {

                const methodName = propKey as ViewNavigatorEntityServiceLibMethodRecordKey;
                // Match both methods
                if (VIEW_NAVIGATOR_ENTITY_SERVICELIB_METHODS[methodName]) {

                // Note: This wrapper is NOT marked as 'async'
                return function (this: any, ...args: any[]) {

                    // 1. Execute the original method
                    const result = targetValue.apply(this, args);

                    // 2. Check if the result is a Promise (meaning the method was async)
                    if (result instanceof Promise) {
                    // Wait for the promise to resolve, call someFunction, and pass the value down
                    return result.then((resolvedResult) => {
                        this.pushViewHostContextSvc(methodName, resolvedResult);
                        return resolvedResult;
                    });
                    }

                    // 3. If it's not a Promise (meaning the method was sync)
                    // Call someFunction immediately and return the value
                    this.pushViewHostContextSvc(methodName, result);
                    return result;
                };
                }
            }

            return targetValue;
            },
        });
    }

    pushViewHostContextSvc<T extends ViewNavigatorEntityServiceLibMethodRecordKey>(
        methodName: T,
        methodResult: Awaited<ReturnType<AzavistaApiService[T]>>,
    ) {
        this._viewHostContextSvc.pushServiceLibMethodResult(methodName, methodResult);
    }
}
